import { get, post } from '@eika-infrastruktur/request';

import { getRequestOptions } from '../../meldskade/reducer/skademelding-actions';
import { KlageDTO, SporsmalsflytDTO, SporsmalsflytResultDTO } from '../../types/generated-types';
import { hentKlagePostUrl, hentKlageUrl } from '../../urler';

export interface KlageResult {
    status: KlageStatusDTO;
    message: string;
}

export enum KlageStatusDTO {
    IkkeValidert = 'IkkeValidert',
    FailedVedleggDoesNotExist = 'FailedVedleggDoesNotExist',
    FailedEpostutsendingNotSuccessful = 'FailedEpostutsendingNotSuccessful',
    FailedUnexpectedVedleggException = 'FailedUnexpectedVedleggException',
    FailedUploadingVedlegg = 'FailedUploadingVedlegg',
    Ok = 'Ok',
}

export enum KlageActionKeys {
    FetchingKlageSporsmalsflyt = 'FETCHING_KLAGE_SPORSMALSFLYT',
    FetchedKlageSporsmalsflyt = 'FETCHED_KLAGE_SPORSMALSFLYT',
    FetchingKlageSporsmalsflytFailed = 'FETCHING_KLAGE_SPORSMALSFLYT_FAILED',
    SaveKlage = 'SAVE_KLAGE',
    SaveKlageSuccess = 'SAVE_KLAGE_SUCCESS',
    SaveKlageFailure = 'SAVE_KLAGE_FAILURE',
    SaveKlageVedleggFailure = 'SAVE_KLAGE_VEDLEGG_FAILURE',
}

export interface FetchingKlageSporsmalsflytsAction {
    type: KlageActionKeys.FetchingKlageSporsmalsflyt;
}

export const fetchingKlageSporsmalsflyt = (): FetchingKlageSporsmalsflytsAction => ({
    type: KlageActionKeys.FetchingKlageSporsmalsflyt,
});

export interface FetchedKlageSporsmalsflytAction {
    type: KlageActionKeys.FetchedKlageSporsmalsflyt;
    sporsmalsflyt: SporsmalsflytDTO;
}

export const fetchedKlageSporsmalsflyt = (sporsmalsflyt: SporsmalsflytDTO): FetchedKlageSporsmalsflytAction => ({
    type: KlageActionKeys.FetchedKlageSporsmalsflyt,
    sporsmalsflyt,
});

export interface FetchingKlageSporsmalsflytFailedAction {
    type: KlageActionKeys.FetchingKlageSporsmalsflytFailed;
}

export const fetchKlageSporsmalsflytFailed = (): FetchingKlageSporsmalsflytFailedAction => ({
    type: KlageActionKeys.FetchingKlageSporsmalsflytFailed,
});

export interface SaveKlageAction {
    type: KlageActionKeys.SaveKlage;
}

export const saveKlage = (): SaveKlageAction => ({
    type: KlageActionKeys.SaveKlage,
});

export interface SaveKlageSuccessAction {
    type: KlageActionKeys.SaveKlageSuccess;
}

export const saveKlageSuccess = (): SaveKlageSuccessAction => ({
    type: KlageActionKeys.SaveKlageSuccess,
});

export interface SaveEtersendingFailureAction {
    type: KlageActionKeys.SaveKlageFailure;
}

export const saveKlageFailure = (): SaveEtersendingFailureAction => ({
    type: KlageActionKeys.SaveKlageFailure,
});

export interface SaveKlageVedleggFailureAction {
    type: KlageActionKeys.SaveKlageVedleggFailure;
}

export const saveKlageVedleggFailure = (): SaveKlageVedleggFailureAction => ({
    type: KlageActionKeys.SaveKlageVedleggFailure,
});

export const sendKlageApi = async (klage: KlageDTO, bankregnr: string): Promise<KlageResult> =>
    post<KlageResult>(hentKlagePostUrl(), klage, getRequestOptions(bankregnr));

export const getKlageApi = async (bankregnr: string): Promise<SporsmalsflytResultDTO> =>
    get(hentKlageUrl(), getRequestOptions(bankregnr));
